@if (group) {
  <ng-container [formGroup]="group">
    <ng-container *ngTemplateOutlet="formField"></ng-container>
  </ng-container>
}

@if (!group) {
  <ng-container *ngTemplateOutlet="formField"></ng-container>
}

<ng-template #formField>
  <div class="container">
    @if (!hideIconSpace) {
      <mat-icon [ngClass]="{ focus: input.focused }">{{ icon }}</mat-icon>
    }
    <mat-form-field color="accent">
      <mat-label>
        @if (dontCapitalizeFirst == null || dontCapitalizeFirst == false) {
          {{ label | titlecase }}
        }
        @if (dontCapitalizeFirst == true) {
          {{ label }}
        }
      </mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="control" #input="matInput" (dateInput)="onEmitDateChange($event.value)" autocomplete="off"/>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker [touchUi]="isTouchDevice"></mat-datepicker>
      <mat-hint [ngClass]="{ highlight: isHintHighlighted, warn: isHintWarning }">{{ hint }}</mat-hint>
      @if (control.errors?.msError) {
        <mat-error>{{ control.errors?.msError == msErrorKey ? customMsError : control.errors?.msError }}</mat-error>
      }
      @if (control.errors?.required && !control.errors?.matDatepickerParse) {
        <mat-error>{{ sysText.required | capitalizefirst }}</mat-error>
      }
      @if (control.errors?.matDatepickerParse) {
        <mat-error>{{ sysText.invalidDateError }}</mat-error>
      }
    </mat-form-field>
    @if (info) {
      <!-- a button so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="sysText.moreInformation_ariaLabel"
        [matTooltip]="info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    }
  </div>
</ng-template>
